export const getCityId = (item) => item?._id || item?.id || "";

export const getCityName = (item) => item?.city_name || item?.name || item?.city || "N/A";

export const getPincodeCount = (item) =>
  item?.total_pincodes ?? item?.pincode_count ?? item?.total_pincode_count ?? 0;

export const parseCityList = (payload) => {
  if (Array.isArray(payload)) return payload;
  return payload?.data || payload?.result || payload?.cities || [];
};

export const getLocationId = (item) => item?._id || item?.id || item?.location_id || "";

export const getLocationName = (item) =>
  item?.location || item?.location_name || item?.name || "N/A";

export const parseLocationList = (payload) => {
  if (Array.isArray(payload)) return payload;
  return payload?.data || payload?.result || payload?.locations || [];
};

export const parsePincodeList = (payload) => {
  if (Array.isArray(payload)) return payload;
  return (
    payload?.data ||
    payload?.result ||
    payload?.list ||
    payload?.pin_codes ||
    payload?.pincodes ||
    payload?.pincodeList ||
    []
  );
};

export const getPincodeId = (item) =>
  item?._id ||
  item?.id ||
  item?.pincode_id ||
  item?.pin_code_id ||
  item?.pincodeId ||
  "";

export const getPincodeValue = (item) =>
  item?.pin_code || item?.pincode || item?.code || "";

export const parsePincodeListResponse = (payload) => {
  if (Array.isArray(payload)) {
    return { list: payload, totalPages: 1 };
  }

  const list = parsePincodeList(payload);
  const totalPages =
    payload?.pagination?.totalPages ||
    payload?.totalPages ||
    Math.max(1, Math.ceil(list.length / 10));

  return { list, totalPages };
};

/** Normalizes a pincodeList API row for the manage-pincodes table */
export const mapPincodeListRow = (item, index = 0) => {
  const pincodeId = getPincodeId(item);
  const locationId = getLocationId(item?.location_id || item);
  const cityId = item?.city_id || getCityId(item?.city_id || item?.city || item);

  return {
    rowId: pincodeId || `pincode-row-${index}`,
    cityId,
    cityName:
      item?.city_name ||
      getCityName(item?.city) ||
      getCityName(item),
    locationId,
    locationName: getLocationName(item),
    pincodeId,
    pincode: getPincodeValue(item),
    raw: item,
  };
};
